module.exports = __webpack_public_path__ + "static/media/ic_tick_circle_green.caf60dc1.svg";